const getters = {
  bigPage(state) {
    return state.page;
  }
};
export default getters;
